module.exports = __webpack_public_path__ + "static/img_9836-f69743f2bd50f03ebc865b4470a90e2c.webp";